import PropTypes from 'prop-types';
import {
  Box,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  useDisclosure,
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getClassRecordsAction } from 'store/modules/class/class-action';
import {
  FILE_SUBMISSION_ID,
  INTERACTIVE_ID,
  NARRATIVE_ID,
  QUIZ_ID,
  VIDEO_ID,
} from 'utils/constants/subQuestType';
import { useSearchParams } from 'react-router-dom';
import { ReducerStatus } from 'utils/constants';
import { classActions } from 'store/modules/class/class-slice';
import OverallRecord from './OverallRecord';
import SubQuestRecord from './SubQuestRecord';
import ClassSubQuestProgressMd from './ClassSubQuestProgressMd';

function ClassRecord({ id, ...rest }) {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const deleteProgression = useSelector(
    (state) => state.subQuestReport.deleteProgression
  );

  const [tabIndex, setTabIndex] = useState(0);
  const [selectedSubQuestId, setSelectedSubQuestId] = useState(null);

  const paramTypeId = searchParams.get('typeId');
  const paramSubQuestId = searchParams.get('subQuestId');
  const paramSearch = searchParams.get('search');

  const handleViewSubQuestProgress = (subQuestId) => {
    setSelectedSubQuestId(subQuestId);
  };

  useEffect(() => {
    dispatch(getClassRecordsAction(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (paramSubQuestId) setSelectedSubQuestId(paramSubQuestId);
  }, [paramSubQuestId]);

  useEffect(() => {
    if (selectedSubQuestId) onOpen();
  }, [selectedSubQuestId, onOpen]);

  useEffect(() => {
    if (deleteProgression.status === ReducerStatus.SUCCEEDED) {
      dispatch(
        classActions.removeProgressionData(deleteProgression.progressionId)
      );
    }
  }, [deleteProgression.status, deleteProgression.progressionId, dispatch]);

  useEffect(() => {
    if (paramTypeId) {
      switch (parseInt(paramTypeId, 10)) {
        case VIDEO_ID:
          setTabIndex(1);
          break;
        case NARRATIVE_ID:
          setTabIndex(2);
          break;
        case INTERACTIVE_ID:
          setTabIndex(3);
          break;
        case QUIZ_ID:
          setTabIndex(4);
          break;
        case FILE_SUBMISSION_ID:
          setTabIndex(5);
          break;
        default:
          setTabIndex(0);
      }
    } else {
      setTabIndex(0);
    }
  }, [paramTypeId]);

  return (
    <Box
      {...rest}
      w="100%"
      p={4}
      color="gray.500"
      borderWidth="1px"
      borderRadius="lg"
    >
      <ClassSubQuestProgressMd
        subQuestId={parseInt(selectedSubQuestId, 10)}
        paramSearch={paramSearch}
        isOpen={isOpen}
        onClose={onClose}
      />

      <Tabs
        index={tabIndex}
        onChange={(index) => setTabIndex(index)}
        isFitted
        variant="enclosed"
      >
        <TabList mb="1em">
          <Tab>Overall Records (Users)</Tab>
          <Tab>Video</Tab>
          <Tab>Narrative</Tab>
          <Tab>Interactive Content</Tab>
          <Tab>Quiz</Tab>
          <Tab>File Submission</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <OverallRecord />
          </TabPanel>
          <TabPanel>
            <SubQuestRecord
              handleViewProgress={handleViewSubQuestProgress}
              typeId={VIDEO_ID}
            />
          </TabPanel>
          <TabPanel>
            <SubQuestRecord
              handleViewProgress={handleViewSubQuestProgress}
              typeId={NARRATIVE_ID}
            />
          </TabPanel>
          <TabPanel>
            <SubQuestRecord
              handleViewProgress={handleViewSubQuestProgress}
              typeId={INTERACTIVE_ID}
            />
          </TabPanel>
          <TabPanel>
            <SubQuestRecord
              handleViewProgress={handleViewSubQuestProgress}
              typeId={QUIZ_ID}
            />
          </TabPanel>
          <TabPanel>
            <SubQuestRecord
              handleViewProgress={handleViewSubQuestProgress}
              typeId={FILE_SUBMISSION_ID}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}

ClassRecord.propTypes = {
  id: PropTypes.number.isRequired,
};

export default ClassRecord;
